/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'

type Props = {
  className: string
  title?: string
  product?: any[]

}

const ListsWidget3: React.FC<Props> = ({className, title, product}) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title fw-bold text-dark'>{title}</h3>
        {/* <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 />
        </div> */}
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-2'>
        {
          product!.map((e, i) => (
            <div className='d-flex align-items-center mb-8' key={i}>
            <span className='bullet bullet-vertical h-40px bg-success'></span>
            <div className='flex-grow-1 mx-5'>
              <a href='#' className='text-gray-800 text-hover-primary fw-bold fs-6'>
                {e.name}
              </a>
              <span className='text-muted fw-semibold d-block'>Voucher Shopee</span>
            </div>
            <span className='badge badge-light-success fs-8 fw-bold'>{e.redeemed} Voucher</span>
          </div>
          ))
        }
        
      
        {/* <div className='d-flex align-items-center mb-8'>
          <span className='bullet bullet-vertical h-40px bg-primary'></span>
          <div className='form-check form-check-custom form-check-solid mx-5'>
            <input className='form-check-input' type='checkbox' value='' />
          </div>
          <div className='flex-grow-1'>
            <a href='#' className='text-gray-800 text-hover-primary fw-bold fs-6'>
              KPI App Showcase
            </a>
            <span className='text-muted fw-semibold d-block'>Due in 2 Days</span>
          </div>
          <span className='badge badge-light-primary fs-8 fw-bold'>New</span>
        </div> */}
      </div>
    </div>
  )
}

export {ListsWidget3}
